document.addEventListener("DOMContentLoaded", function() {


  // ============================
  // STICKY ADD TO CART BUTTON
  // ============================

// if (document.body.classList.contains('template-product')) {
  
//   const productForm = document.querySelector('.product-form');
//   const stickyheader = document.querySelector('.waiting_popup_header');
//   const footer = document.querySelector('.footer_bottom');
//   const productCenter = productForm?.closest('.product_center');
//   const customSticky = document.querySelector('.custom_sticky_div_wrap');

//   console.log(productForm);
//   console.log(stickyheader);
//   console.log(footer);
//   console.log(productCenter);
//   console.log(customSticky);

//   if (!productForm || !stickyheader || !footer || !productCenter || !customSticky) return;

//   const ACTIVE_CLASS = 'sticky_add_to_cart';

//   const headerHeight = stickyheader.offsetHeight;
//   const triggerPoint = productForm.getBoundingClientRect().top + window.scrollY - headerHeight;

//   const placeholder = document.createElement('div');
//   placeholder.style.height = `${productCenter.offsetHeight}px`;

//   let isSticky = false;

//   function isFooterHalfVisible() {
//     const footerRect = footer.getBoundingClientRect();
//     return footerRect.top + footerRect.height / 2 <= window.innerHeight;
//   }

//   function handleScroll() {
//     const scrollY = window.scrollY;
//     console.log("scrollY ==>");
//     console.log(scrollY);
//     if (isFooterHalfVisible()) {
//       if (isSticky) {
//         productCenter.classList.remove(ACTIVE_CLASS);
//         placeholder.replaceWith(productCenter);
//         isSticky = false;
//       }
//       return;
//     }

//     // Activate sticky
//     if (!isSticky && scrollY >= triggerPoint) {
//       productCenter.classList.add(ACTIVE_CLASS);
//       productCenter.after(placeholder);
//       customSticky.appendChild(productCenter);
//       isSticky = true;
//     }

//     // Deactivate when scrolling back up
//     if (isSticky && scrollY < triggerPoint) {
//       productCenter.classList.remove(ACTIVE_CLASS);
//       placeholder.replaceWith(productCenter);
//       isSticky = false;
//     }
//   }

//   window.addEventListener('scroll', handleScroll);

// }

  // ============================
  // ON BUTTON CLICK HANDLING MODAL POPUP ON PRODUCT PAGE
  // ============================

  const modalBtns = document.querySelectorAll('.ingredient_details_modal');
  const modalCloseBtn = document.querySelector('.product_section_close');
  const modalOvelayBtn = document.querySelector('.product_section-overlay');  

  const closeModalPopup = () => {
    document.body.classList.remove('is_open_ingredient_details');
  };

  if (modalBtns) {
    modalBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        document.body.classList.add('is_open_ingredient_details');
      })
    })
  }  
  if (modalOvelayBtn ) {
    modalOvelayBtn.addEventListener('click', closeModalPopup);    
  }
  if (modalCloseBtn ) {
    modalCloseBtn.addEventListener('click', closeModalPopup);    
  }



  // ============================
  // TAB BUTTON CLICK HANDLING
  // ============================

  // const tabButtons = document.querySelectorAll('.tablinks');
  // const tabPanels = ['ingredients_tab', 'nutrition_tab'];
  // const mobileTitle = document.querySelector('.tab_title_mobile_new h5');
  // const dropdownContainer = document.querySelector('.tab.common_tab_new');

  // tabButtons.forEach(btn => {
  //   btn.addEventListener('click', () => {

  //     // Remove active from all buttons
  //     tabButtons.forEach(b => b.classList.remove('active'));
  //     btn.classList.add('active');

  //     // Update mobile title
  //     const text = btn.textContent.trim();
  //     if (mobileTitle) mobileTitle.textContent = text;

  //     // Hide all tab panels
  //     tabPanels.forEach(id => {
  //       const panel = document.getElementById(id);
  //       if (panel) panel.style.display = 'none';
  //     });

  //     // Show selected panel
  //     const targetID = btn.getAttribute('data-target');
  //     const targetPanel = document.getElementById(targetID);
  //     if (targetPanel) targetPanel.style.display = 'block';

  //     // Close mobile dropdown (if open)
  //     if (dropdownContainer) dropdownContainer.classList.remove('show_dropdown');
  //   });
  // });


  // ============================
  // MOBILE DROPDOWN HANDLING
  // ============================

  // const mobileTitleWrapper = document.querySelector('.tab_title_mobile_new');

  // if (mobileTitleWrapper) {
  //   mobileTitleWrapper.addEventListener('click', () => {
  //     dropdownContainer?.classList.add('show_dropdown');
  //   });
  // }

  // if (dropdownContainer) {
  //   dropdownContainer.addEventListener('click', () => {
  //     dropdownContainer.classList.remove('show_dropdown');
  //   });
  // }





    // CLOSE offer form
  const offerFormOpen = document.querySelector('.dicount_save');
  const offerFormclosed = document.querySelector('.dis_popup_close_block');
  const offerFormOverlay = document.querySelector('.discount_popup_overlay');

  const closeOfferForm = () => {
    document.body.classList.remove('is_open_offer_form');
  };

  if (offerFormOpen) {
    offerFormOpen.onclick = () => document.body.classList.add('is_open_offer_form');
  }

  if (offerFormOverlay ) {
    offerFormOverlay.addEventListener('click', closeOfferForm);    
  }
  if (offerFormclosed ) {
    offerFormclosed.addEventListener('click', closeOfferForm);    
  }
    // Product Table data
  const productTableOpen = document.querySelector('.show_product_table');
  const productTableclosed = document.querySelector('.table_close_block');
  const productTableOverlay = document.querySelector('.product_table_overlay');

  console.log("productTableOpen==>");
  console.log(productTableOpen);
  const closeProductTable = () => {
    document.body.classList.remove('is_open_product_table');
  };

  if (productTableOpen) {
    productTableOpen.onclick = () => document.body.classList.add('is_open_product_table');
  }

  if (productTableOverlay ) {
    productTableOverlay.addEventListener('click', closeProductTable);    
  }
  if (productTableclosed ) {
    productTableclosed.addEventListener('click', closeProductTable);    
  }

  // FAQ tab js
    const countdownheight = document.querySelector(".countdown-section");
    // const announcement = document.querySelector(".announcement_bar").offsetHeight;
    const announcement = document.querySelector(".announcement_bar");
    if( countdownheight ){
      let countdownHeightnew = countdownheight.offsetHeight;
      console.log(countdownHeightnew, "countdownHeightnew");
      document.body.style.setProperty('--countdown-height', countdownHeightnew + 'px');
    }
    if( countdownheight && announcement ){
      let botheight = countdownheight.offsetHeight+announcement;
      document.body.style.setProperty('--countdown-annouc-height', botheight + 'px');
    }
    const header = document.querySelector("header");
    // const header = document.querySelector("header").offsetHeight;
    const navHeight = header + announcement + 66;
    console.log(navHeight)
    document.querySelectorAll('.faq_left_inner a').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.faq_left_inner a')
        .forEach(a => a.classList.remove('active'));
        this.classList.add('active');
      const href = this.getAttribute('href');
      const id = href.startsWith('#') ? href.substring(1) : href;
      const target = document.getElementById(id);
      if (!target) return;
      const offset = navHeight;
      const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: topPos,
        behavior: "smooth"
      });
    });
  });

  // MOBILE MEGA OPEN AND CLOSE JS
  document.querySelectorAll('.menu_list').forEach(link => {
      link.addEventListener('click', function (e) {
          //e.preventDefault();
          const parent = this.parentElement;
          const mega = parent.querySelector('.mega_menu');
          if(mega){
            document.querySelectorAll('.menu_item.active').forEach(item => {
              if (item !== parent) {
                item.classList.remove('active');
                const mm = item.querySelector('.mega_menu');
                if (mm) mm.style.maxHeight = 0;
              }
            });
            parent.classList.toggle('active');
            if (parent.classList.contains('active')) {
              mega.style.maxHeight = mega.scrollHeight + "px";
            } else {
              mega.style.maxHeight = 0;
            }
          }
      });
  });


  // WAITING POPUP JS CODE
  // window.addEventListener('load', function () {
  //   const popup = document.querySelector('.waiting_popup');
  //   popup.classList.add('active');
  //   const isShown = localStorage.getItem('popupShown');
  //   if (!isShown) {
  //     const popup = document.querySelector('.waiting_popup');
  //     popup.classList.add('active');
  //     setTimeout(() => {
  //       popup.classList.remove('active');
  //       localStorage.setItem('popupShown', 'true');
  //     }, 5000);
  //   }
  // });



  // ACCODIAN JS CODE
  const accordionGroups = document.querySelectorAll(".faq_accordion_item");
      if (accordionGroups.length > 0) {
        accordionGroups.forEach((group, groupIndex) => {
            const accordions = group.querySelectorAll(".faq_accordion_title");
            const parent = group.parentNode;
            const accordionsAll = parent.querySelectorAll(".faq_accordion_title");
      
            accordions.forEach((accordion, index) => {
                const panel = accordion.nextElementSibling;
      
                if (accordion.classList.contains("active")) {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
      
                accordion.addEventListener("click", () => {
                    const isActive = accordion.classList.contains("active");
      
                    accordionsAll.forEach((acc) => {
                        acc.classList.remove("active");
                        const accPanel = acc.nextElementSibling;
                        accPanel.style.maxHeight = null; 
                    });
      
                    if (!isActive) {
                        accordion.classList.add("active");
                      panel.style.maxHeight = panel.scrollHeight + "px";
                    }
                });

            });
        });
      }
      
  // HEADER SCROLL ADD STCKY CLASS
  window.addEventListener("scroll", function () {
    const scroll = window.scrollY;
    if (scroll >= 10) {
      document.querySelector("header").classList.add("on-sticky");
    } else {
      document.querySelector("header").classList.remove("on-sticky");
    }
  });

  // MOBILE MENU ADD REMOVE CLASS
  if(document.querySelector('.header_hamburger a') ){

    document.querySelector('.header_hamburger a').addEventListener('click', function(e) {
      e.preventDefault();
      const headerMain = document.querySelector('.header_main');
      if (headerMain.classList.contains('is-active')) {
        headerMain.classList.remove('is-active');
      } else {
        headerMain.classList.add('is-active');
      }
    });
  }


  // REVIEW SLIDER JS
  var review_slider = new Swiper(".review_slider", {
    slidesPerView: 1,
    spaceBetween: 18,
    pagination: {
      el: ".swiper-pagination.review_pagination",
      clickable: true,
    },
    breakpoints: {
      526: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 18,
      }
    },
  });

  // Header and announcement and hero section height sapching js
  function applySpacing() {
    const announcement = document.querySelector('.announcement_bar');
    const header = document.querySelector('.header');
    const bodyIsHome = document.body.classList.contains('template-index');
    const wrapper =
      (announcement?.offsetHeight || 0) + (header?.offsetHeight || 0);
    document.body.style.setProperty('--top-spacing', wrapper + 'px');
  }

  applySpacing();
  window.addEventListener('resize', applySpacing);
  window.addEventListener('orientationchange', applySpacing);


  // MENU HEIGHT GET IN OPEN JS
  function menutop() {
    var announcement = document.querySelector('.announcement_bar');
    var header = document.querySelector('.header');
    var wrapper = document.querySelector('.header_center');
    if (window.innerWidth <= 850) {
      } else {
        var wrapper = document.querySelector('.header_center');
        if (wrapper) wrapper.style.top = '';
    }
    if (wrapper) {
      var totalHeight = 0;
      if (announcement) totalHeight += announcement.offsetHeight;
      if (header) totalHeight += header.offsetHeight;
      document.body.style.setProperty('--wrapper-top', totalHeight + 'px');
    }
  }

  menutop();
  window.addEventListener('resize', menutop);
  window.addEventListener('orientationchange', menutop);


  // SHOP SECTION SLIDER JS
  var shop_wpr = new Swiper(".shop_wpr", {
    slidesPerView: 1.15,
    spaceBetween: 24,
    slidesOffsetAfter: 20,
    slidesOffsetBefore: 0,
    breakpoints: {
      526: {
        slidesPerView: 1.7,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
      },
      851: {
        slidesPerView: 3,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 0,
      }
    },
  });

  // SHOP SECTION SLIDER JS
  var ingredient_slider = new Swiper(".ingredient_slider", {
    slidesPerView: 1.103,
    spaceBetween: 12,
    slidesOffsetAfter: 16,
    breakpoints: {
      526: {
        slidesPerView: 2.2,
        spaceBetween: 12,
      },
      992: {
        slidesPerView: 2.88,
        spaceBetween: 20,
      }
    },
  });

  let swiper, last;
  function hoverOn() {
    const slides = document.querySelectorAll('.moment_main_slider .swiper-slide');
    last = document.querySelector('.moment_main_slider .swiper-slide.hover');
    slides.forEach(s => {
      s.onmouseenter = () => {
        if (last && last !== s) last.classList.remove('hover');
        s.classList.add('hover');
        last = s;
      };
      s.onmouseleave = null;
    });
  }


  // FULL WIDTH SLIDER JS
  function hoverOff() {
    document.querySelectorAll('.moment_main_slider .swiper-slide').forEach(s => {
      s.onmouseenter = s.onmouseleave = null;
      s.classList.remove('hover');
    });
    last = null;
  }
  function init() {
    if (window.innerWidth <= 850) {
      hoverOff();
      if (!swiper) {
        swiper = new Swiper(".moment_main_slider", {
          slidesPerView: 1.124,
          spaceBetween: 10,
          slidesOffsetAfter: 16,
          breakpoints: {
            526: { slidesPerView: 1.8, spaceBetween: 15, slidesOffsetAfter: 16 }
          }
        });
      }
    } else {
      if (swiper) swiper.destroy(true, true), swiper = null;
      hoverOn();
    }
  }


  init();
  window.addEventListener("resize", init);

  // cart open and close
  // document.querySelector('.cart a').onclick = e => {
  //   e.preventDefault();
  //   document.body.classList.add('cart-open');
  // };

  // document.querySelector('.cart_close a').onclick =
  // document.querySelector('.cart_drawer_overlay').onclick = () =>
  //   document.querySelector('body').classList.remove('cart-open');
  //   document.body.classList.remove('cart-open');



  function initCartDrawerEvents() {
  const body = document.body;

  // OPEN CART
  const cartOpen = document.querySelector('.cart a');
  if (cartOpen) {
    cartOpen.onclick = e => {
      e.preventDefault();
      body.classList.add('cart-open');
    };
  }

  // CLOSE CART
  const closeBtn = document.querySelector('.cart_close a');
  const overlay = document.querySelector('.cart_drawer_overlay');

  if (closeBtn) {
    closeBtn.onclick = () => body.classList.remove('cart-open');
  }

  if (overlay) {
    overlay.onclick = () => body.classList.remove('cart-open');
  }
 }
 
  // Run on page load
  document.addEventListener("DOMContentLoaded", initCartDrawerEvents);

  // Run again when Shopify reloads cart section
  document.addEventListener("shopify:section:load", initCartDrawerEvents);


// product slider js
  window.productThumbSwiper = new Swiper('.product_hero_thumbh', {
    direction: 'horizontal',
    spaceBetween: 10,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        direction: 'vertical',
        slideToClickedSlide: true,
      },
    },
  });

  window.productMainSwiper = {
    slidesPerView: 1,
    spaceBetween: 0,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next.product_hero_arrow",
      prevEl: ".swiper-button-prev.product_hero_arrow",
    },
  };

  var parentThumbLeft = document.querySelector('[data-desktop-layout="thumbnails-left"] .product_hero_main');
  if (parentThumbLeft) {
    window.productMainSwiper.thumbs = { swiper: window.productThumbSwiper };
  }
  let stackedSwiper = null;
  function handleStackedSlider() {
    const stackedLayout = document.querySelector('[data-desktop-layout="stacked"] .product_hero_main');
    if (!stackedLayout) return;
    if (window.innerWidth <= 767) {
      if (!stackedSwiper) {
        stackedSwiper = new Swiper('[data-desktop-layout="stacked"] .product_hero_main', window.productMainSwiper);
      }
    } else {
      if (stackedSwiper) {
        stackedSwiper.destroy(true, true);
        stackedSwiper = null;
      }
    }
  }

  handleStackedSlider();
  window.addEventListener("resize", handleStackedSlider);
  var product_hero_main = new Swiper(
    '[data-desktop-layout="thumbnails-left"] .product_hero_main, [data-desktop-layout="carousel"] .product_hero_main',
    window.productMainSwiper
  );



  // PRODUCT PAGE INFO TABING JS
  document.querySelectorAll('.has_parent').forEach(parent => {
    const tabs = parent.querySelectorAll('ul.tabs li');
    const contents = parent.querySelectorAll('.tab_content');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('current'));
        contents.forEach(c => c.classList.remove('current'));

        tab.classList.add('current');
        contents[i].classList.add('current');
      });
    });
  });

  // PRODUCT PAGE INFO BOTTOM SLIDER JS 
  var product_bottom_slider = new Swiper(".product_bottom_slider", {
      slidesPerView: 2.53,
      spaceBetween: 12,
      slidesOffsetAfter: 12,
      breakpoints: {
        576: {
          slidesPerView: 3.53,
          spaceBetween: 12,
        }
      },
    });


    // ============================
    // ON BLOG PAGE LOAD MORE
    // ============================

    const container = document.getElementById('blog-articles');
    const loadMoreBtn = document.getElementById('load-more-btn');
    
    if (!container || !loadMoreBtn) return;

    let page = 1;
    const blogHandle = container.dataset.blogHandle;
    const limit = parseInt(container.dataset.limit);
    const blogTotal = parseInt(container.dataset.total);

    loadMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();
        page++;

        fetch(`/blogs/${blogHandle}?page=${page}&view=load-more&limit=${limit}`)
            .then(res => res.text())
            .then(html => {
              if (!html.trim()) {
                loadMoreBtn.style.display = 'none';
                return;
              }

              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const blogWrapper = doc.querySelector('#get_load_more');

              console.log(`limit ${limit}`);
              console.log(`page ${page}`);
              if (!blogWrapper) {
                loadMoreBtn.style.display = 'none';
                return;
              }
              container.insertAdjacentHTML('beforeend', blogWrapper.innerHTML);

              const articlesLoaded = page * limit;
              if (articlesLoaded >= blogTotal) {
                loadMoreBtn.style.display = 'none';
              }           
            })
            .catch(err => console.error('Error loading more articles:', err));
    });      
});


